import {
  Button,
  Card,
  CheckList,
  Dropdown,
  DropdownRef,
  Empty,
  SearchBar,
  SearchBarRef,
  InfiniteScroll,
} from 'antd-mobile';

import React, { useEffect, useMemo, useRef, useState } from 'react';
import dayjs from 'dayjs';
import styles from './index.module.scss';
import {
  EnergyConsumptionPlanGetStaffOrgMapping,
  getPlanPage,
  getStaffOrgMapping,
  PlanPageRequest,
  PlanPageResponse,
  TimeDetailItem,
} from '@/api/energy';
import { isEmpty } from 'lodash-es';
import NoData from '@/assets/images/noData.png';
import EnergyPlanImg from '@/assets/images/energyplan@2x.png';
import { useNavigate } from 'react-router-dom';

export enum OperationType {
  BatchClear = 1,
  BatchConfig = 2,
}

// 定义日期对象类型
export interface DateItem {
  date: string;
  detailList?: TimeDetailItem[];
}

const EnergyUsePlanList = () => {
  const navigate = useNavigate();
  const [areaList, setAreaList] = useState<EnergyConsumptionPlanGetStaffOrgMapping['areaList']>();
  const [selectedArea, setSelectedArea] = useState<number[]>([]);
  const [searchParams, setSearchParams] = useState<PlanPageRequest>({ page: 1, size: 20 });
  const [planList, setPlanList] = useState<PlanPageResponse[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [searchAreaText, setSearchAreaText] = useState('');
  const ref = useRef<DropdownRef>(null);
  const searchZoneRef = useRef<SearchBarRef>(null);

  useEffect(() => {
    document.title = '用能计划';
  }, []);

  useEffect(() => {
    getStaffOrgMapping().then(res => {
      setAreaList(res.areaList ?? []);
    });
  }, []);

  useEffect(() => {
    // 搜索或筛选时重置列表
    getPlanPage(searchParams).then(res => {
      if (searchParams.page === 1) {
        setPlanList(res.list ?? []);
      } else {
        setPlanList(prev => [...prev, ...(res.list ?? [])]);
      }
      setHasMore(res.list?.length > 0 && res.total > 20);
    });
  }, [searchParams]);

  // 下拉加载更多
  const loadMore = async () => {
    const nextPage = searchParams.page! + 1;
    setSearchParams(prev => ({ ...prev, page: nextPage }));
  };

  const filteredAreaItems = useMemo(() => {
    return areaList?.filter(item => item.zoneName!.includes(searchAreaText));
  }, [areaList, searchAreaText]);

  return (
    <div className={styles.container}>
      <Dropdown
        ref={ref}
        onChange={key => {
          if (key) {
            setSelectedArea(searchParams.zoneIdList ?? []);
          } else {
            setSearchAreaText('');
            searchZoneRef.current?.clear();
          }
        }}
      >
        <Dropdown.Item
          key="zoneIdList"
          title="区域名称"
          style={{ color: isEmpty(searchParams!.zoneIdList) ? '' : 'var(--adm-color-primary)' }}
        >
          <div className={styles.dropdownPanel}>
            <SearchBar placeholder="请输入区域名称" ref={searchZoneRef} onChange={setSearchAreaText} />
            {!isEmpty(filteredAreaItems) ? (
              <CheckList
                multiple
                value={selectedArea}
                onChange={val => {
                  setSelectedArea(val as number[]);
                }}
              >
                {filteredAreaItems?.map(item => (
                  <CheckList.Item key={item.id} value={item.id!}>
                    {item.zoneName}
                  </CheckList.Item>
                ))}
              </CheckList>
            ) : (
              <div className={styles.emptyState}>
                <Empty image={NoData} description="暂无数据" />
              </div>
            )}
            <div className={styles.actionBar}>
              <Button size="large" onClick={() => setSelectedArea([])}>
                重置
              </Button>
              <Button
                size="large"
                color="primary"
                fill="solid"
                onClick={() => {
                  setSearchParams(prev => ({ ...prev, page: 1, zoneIdList: selectedArea }));
                  ref.current?.close();
                }}
              >
                确定
              </Button>
            </div>
          </div>
        </Dropdown.Item>
      </Dropdown>
      {!isEmpty(planList) ? (
        <div className={styles.list}>
          {planList.map((item, index) => (
            <Card
              key={index}
              // title={
              //   <div className={styles.title}>
              //     <img src={EnergyPlanImg} alt="用能计划" width={20} />
              //     {item.code}
              //   </div>
              // }
              className={styles.card}
              onClick={() =>
                navigate(
                  `/intelligent-platform/energyUse/plan/detail/${item.id}?code=${item.code}&editable=${item.editable}`
                )
              }
            >
              <div className={styles.cardDetail}>
                <div>
                  部门：<span className={styles.value}>{item.ownerOrgName}</span>
                </div>
                <div>
                  区域：
                  <span className={styles.value}>{item.zoneName ?? '-'}</span>
                </div>
                <div>
                  申请人：
                  <span className={styles.value}>{item.applyUserName ?? '-'}</span>
                </div>
                <div>
                  申请时间：
                  <span className={styles.value}>
                    {item.applyTime ? dayjs(item.applyTime).format('YYYY-MM-DD HH:mm:ss') : '-'}
                  </span>
                </div>
                <div>
                  申请计划时间范围：
                  <span className={styles.value}>{item.timeRange ?? '-'}</span>
                </div>
                <div>
                  申请能源介质：
                  <span className={styles.value}>{item.energyMedium ?? '-'}</span>
                </div>
              </div>
            </Card>
          ))}
          <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        </div>
      ) : (
        <div className={styles.emptyState}>
          <Empty image={NoData} description="暂无数据" />
        </div>
      )}
    </div>
  );
};

export default EnergyUsePlanList;
